import IconButton from "@mui/material/IconButton";
import SnackbarContent from "@mui/material/SnackbarContent";
//import {withStyles} from '@mui/styles';

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { forwardRef } from "react";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = (theme) => ({
  successAlert: {
    backgroundColor: "red" /* theme?.palette?.success?.main */,
  },
  errorAlert: {
    backgroundColor: "green" /* theme?.palette?.error?.main */,
  },
  infoAlert: {
    backgroundColor: "red" /* theme?.palette?.info?.main */,
  },
  warningAlert: {
    backgroundColor: "red" /* theme?.palette?.warning?.main */,
  },
  message: {
    display: "flex",
    alignItems: "center",
    "& > svg": {
      /* marginRight: theme?.spacing?.(1), */
    },
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
  },
  closeButton: {},
});

function SnackbarContentWrapper(props, ref) {
  const { className, message, onClose, variant, ...other } = props;

  const color = {
    success: '#4caf50',
    warning: '#ff9800',
    error: '#ef5350',
    info: '#42a5f5',
  };
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      name="MuiDropzoneSnackbar"
      ref={ref}
      className={className}
      style={{ backgroundColor: color[variant] }}
      
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" style={{display:"flex", alignItems:"center"}}>
          <Icon sx={{fontSize:20, opacity:0.9}} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
         
          onClick={onClose}
        >
          <CloseIcon sx={{fontSize:20, opacity:0.9}} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

/* SnackbarContentWrapper.propTypes = {
  //classes: PropTypes.object.isRequired ?? styles,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
}; */

export default forwardRef(SnackbarContentWrapper);
